const key = "qQduYKJbF83SwfR8rdRU";
const map = new maplibregl.Map({
  container: "map", // container id
  style: `https://api.maptiler.com/maps/2a59fbf8-8d56-4fd2-8578-00171ea0d9bf/style.json?key=${key}`, // style URL
  center: [10.949324351751606, 50.02633859565684], // starting position [lng, lat]
  zoom: 6,
  maxZoom: 8,
  minZoom: 5,
  scrollZoom: false,
});

// Add zoom and rotation controls to the map.
map.addControl(new maplibregl.NavigationControl());

map.on("error", function (err) {
  throw new Error(
    "To load the map, you must replace the API KEY first, see README"
  );
});
// Add geolocate control to the map.
map.addControl(
  new maplibregl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true,
    },
    trackUserLocation: true,
  })
);
// Data
map.on("load", function () {
  map.addSource("geojson-overlay", {
    type: "geojson",
    data: "https://api.maptiler.com/data/e8b838a5-4fa3-4bc3-a510-b2c1ad97ed2a/features.json?key=1YcGhhpSk54YzBwUQM2A",
  });

  map.addLayer({
    id: "geojson-overlay-point",
    type: "circle",
    source: "geojson-overlay",
    filter: ["==", "$type", "Point"],
    layout: {},
    paint: {
      "circle-color": "#FEE400",
      "circle-stroke-color": "#A9B400",
      "circle-stroke-width": 2,
      "circle-radius": 5,
    },
  });
});

// When a click event occurs on a feature in the places layer, open a popup at the
// location of the feature, with description HTML from its properties.
map.on("click", "geojson-overlay-point", function (e) {
  var coordinates = e.features[0].geometry.coordinates.slice();
  var city = e.features[0].properties.ort;

  // Ensure that if the map is zoomed out such that multiple
  // copies of the feature are visible, the popup appears
  // over the copy being pointed to.
  while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
  }

  new maplibregl.Popup()
    .setLngLat(coordinates)
    .setHTML(
      city +
        '<br><a href="https://landvergnuegen.com/products/landvergnuegen-digital"><input type="button" value="Mitglied werden"></a>'
    )
    .addTo(map);
});

// Change the cursor to a pointer when the mouse is over the places layer.
map.on("mouseenter", "geojson-overlay-point", function () {
  map.getCanvas().style.cursor = "pointer";
});

// Change it back to a pointer when it leaves.
map.on("mouseleave", "geojson-overlay-point", function () {
  map.getCanvas().style.cursor = "";
});
